import { Text, Stack, HStack, Tooltip, Icon, Flex } from "@chakra-ui/react";
import {
  textSecondary,
  white,
  whiteAlt,
  color8,
  backgroundLight,
} from "../../../../utils/colors";
import dayjs from "dayjs";
import { TbMailX } from "react-icons/tb";
import StatusButtonTreatmentPlan from "../../../../components/buttons/StatusButtonTreatmentPlan";
import { FaEnvelope } from "react-icons/fa6";

export const columnsMobile = (translate, handleSortChange) => {
  return [
    {
      Header: () => (
        <Flex onClick={() => handleSortChange("treatmentPlanID")} h="100%">
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("patient.columnID")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "treatmentPlanID",
      disableSortBy: true,
      width: 95,
      Cell: ({ row }) => {
        const { treatmentPlanID } = row.original;

        return (
          <Text
            textAlign="left"
            overflow="hidden"
            whiteSpace="nowrap"
            fontSize="xs"
            color={textSecondary}
            fontWeight="500"
          >
            {treatmentPlanID}
          </Text>
        );
      },
    },

    {
      Header: () => (
        <Flex onClick={() => handleSortChange("status")} h="100%">
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("patient.columnStatus")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "status",
      disableSortBy: true,
      preventRowClick: false,
      // width: 100,
      Cell: ({ row }) => {
        const {
          status,

          cancelledFromSharedLink,
          cancelledFromSharedLinkDate,
          cancelledReason,
          cancelledComment,
          publicEmailDate,
          availablePublic,
          emailSentBy,
        } = row.original;

        // console.log("row", row.original);

        let cancelledBy = "-";

        if (cancelledFromSharedLink === true) {
          cancelledBy = translate("patient.patient");
        } else {
          cancelledBy = translate("employee.employee");
        }

        return (
          <HStack gap={0} justify="flex-end">
            {availablePublic && publicEmailDate !== null ? (
              <Tooltip
                p="0.5rem 1rem"
                borderRadius="1rem"
                placement="top"
                label={
                  <Flex direction="column">
                    <Flex align="center" gap="0.25rem">
                      <Text
                        fontSize="xs"
                        color={whiteAlt}
                        fontWeight="500"
                        textAlign="center"
                        whiteSpace="nowrap"
                      >
                        {translate("treatmentPlan.emailSentToPatient")}:
                      </Text>
                      <Text
                        fontSize="xs"
                        color={white}
                        fontWeight="500"
                        textAlign="center"
                        whiteSpace="nowrap"
                        textTransform="capitalize"
                      >
                        {dayjs(publicEmailDate).format("YYYY MMMM D, HH:mm")}
                      </Text>
                    </Flex>
                    <Flex align="center" gap="0.25rem">
                      <Text
                        fontSize="xs"
                        color={whiteAlt}
                        fontWeight="500"
                        textAlign="center"
                        whiteSpace="nowrap"
                      >
                        {translate("treatmentPlan.emailSentToPatientBy")}:
                      </Text>
                      <Text
                        fontSize="xs"
                        color={white}
                        fontWeight="500"
                        textAlign="center"
                        whiteSpace="nowrap"
                        isTruncated
                        maxW="220px"
                      >
                        {emailSentBy &&
                          emailSentBy.lastName &&
                          emailSentBy.lastName}{" "}
                        {emailSentBy && emailSentBy.firstName}
                      </Text>
                    </Flex>
                  </Flex>
                }
              >
                <Flex
                  bg={color8}
                  align="center"
                  justify="center"
                  w="1.25rem"
                  h="1.25rem"
                  borderRadius="10rem"
                  mr="0.75rem"
                >
                  <Icon as={FaEnvelope} fontSize="0.6rem" color={white} />
                </Flex>
              </Tooltip>
            ) : (
              <Flex
                bg={backgroundLight}
                align="center"
                justify="center"
                w="1.25rem"
                h="1.25rem"
                borderRadius="10rem"
                mr="0.75rem"
              >
                <Icon as={TbMailX} fontSize="0.8rem" color={textSecondary} />
              </Flex>
            )}

            <StatusButtonTreatmentPlan
              isUnclickable
              isSmall
              currentStatus={status}
              onUpdateStatus={() => {}}
              options="treatment"
              isTooltip={
                status === "cancelled"
                // || status === "approved"
              }
              tooltipLabel={
                <Stack gap={0} align="flex-start">
                  {status === "cancelled" && (
                    <Flex align="center" justify="center">
                      <Text
                        fontSize="xs"
                        color={whiteAlt}
                        fontWeight="500"
                        textAlign="center"
                        mr={1}
                      >
                        {translate("reason.cancelledBy")}:
                      </Text>
                      <Text
                        isExternal
                        color={white}
                        fontWeight="500"
                        fontSize="xs"
                        isTruncated
                        maxW="128px"
                      >
                        {cancelledBy}
                      </Text>
                    </Flex>
                  )}

                  {status === "cancelled" &&
                    cancelledFromSharedLinkDate !== null && (
                      <Flex align="center" justify="center">
                        <Text
                          fontSize="xs"
                          color={whiteAlt}
                          fontWeight="500"
                          textAlign="center"
                          mr={1}
                        >
                          {translate("reason.cancelledAt")}:
                        </Text>
                        <Text
                          color={white}
                          fontWeight="500"
                          fontSize="xs"
                          isTruncated
                          maxW="160px"
                          textTransform="capitalize"
                        >
                          {dayjs(cancelledFromSharedLinkDate).format(
                            "MMMM D, YYYY, HH:mm"
                          )}
                        </Text>
                      </Flex>
                    )}

                  {status === "cancelled" &&
                    cancelledReason &&
                    cancelledReason.length > 0 && (
                      <Flex align="center" justify="center">
                        <Text
                          fontSize="xs"
                          color={whiteAlt}
                          fontWeight="500"
                          textAlign="center"
                          mr={1}
                        >
                          {translate("reason.cancelledReason")}:
                        </Text>
                        <Text
                          color={white}
                          fontWeight="500"
                          fontSize="xs"
                          isTruncated
                          maxW="128px"
                        >
                          {translate(`reason.${cancelledReason}`)}
                        </Text>
                      </Flex>
                    )}

                  {status === "cancelled" &&
                    cancelledComment &&
                    cancelledComment.length > 0 && (
                      <Flex align="center" justify="center">
                        <Text
                          fontSize="xs"
                          color={whiteAlt}
                          fontWeight="500"
                          textAlign="center"
                          mr={1}
                        >
                          {translate("reason.cancelledComment")}:
                        </Text>
                        <Text
                          color={white}
                          fontWeight="500"
                          fontSize="13px"
                          isTruncated
                          maxW="128px"
                        >
                          {cancelledComment}
                        </Text>
                      </Flex>
                    )}
                </Stack>
              }
            />

            {/* <MoreButtonLite
              id={_id}
              deleteHandler={true}
              setShowDeleteConfirmation={() => {
                setPlanId(_id); // Set the user ID for deletion
                setShowDeleteConfirmation(true); // Open confirmation modal
                setTreatmentPlanID(treatmentPlanID);
              }}
              viewHandler={() => {
                openSidePanelModalHandler(_id);
              }}
              viewLabel={translate("treatmentPlan.editPlan")}
              viewIcon={TbEdit}
              editHandler={() => {
                setPlanId(_id);
                setShowDuplicateModal(true);
                setTreatmentPlanID(treatmentPlanID);
              }}
              editLabel={translate("treatmentPlan.duplicateTreatmentPlan")}
              editId={_id}
              editIcon={TbCopy}
              isSmall
            /> */}
          </HStack>
        );
      },
    },
  ];
};
